__turbopack_context__.v({
  "artistSignature": "NextGen-module-scss-module__dZZU9a__artistSignature",
  "backIcon": "NextGen-module-scss-module__dZZU9a__backIcon",
  "codeBlock": "NextGen-module-scss-module__dZZU9a__codeBlock",
  "collectionHeaderCol": "NextGen-module-scss-module__dZZU9a__collectionHeaderCol",
  "collectionHeaderRow": "NextGen-module-scss-module__dZZU9a__collectionHeaderRow",
  "collectionPreview": "NextGen-module-scss-module__dZZU9a__collectionPreview",
  "collectionPreviewTitle": "NextGen-module-scss-module__dZZU9a__collectionPreviewTitle",
  "collectionProvenanceAccordion": "NextGen-module-scss-module__dZZU9a__collectionProvenanceAccordion",
  "collectionProvenanceAccordionBody": "NextGen-module-scss-module__dZZU9a__collectionProvenanceAccordionBody",
  "collectionProvenanceAccordionBodyOdd": "NextGen-module-scss-module__dZZU9a__collectionProvenanceAccordionBodyOdd",
  "collectionProvenanceAccordionButton": "NextGen-module-scss-module__dZZU9a__collectionProvenanceAccordionButton",
  "collectionProvenanceAccordionButtonHideCaret": "NextGen-module-scss-module__dZZU9a__collectionProvenanceAccordionButtonHideCaret",
  "collectionProvenanceAccordionOdd": "NextGen-module-scss-module__dZZU9a__collectionProvenanceAccordionOdd",
  "collectionTab": "NextGen-module-scss-module__dZZU9a__collectionTab",
  "collectionTabActive": "NextGen-module-scss-module__dZZU9a__collectionTabActive",
  "collectionTabs": "NextGen-module-scss-module__dZZU9a__collectionTabs",
  "collectorSetAccordionBody": "NextGen-module-scss-module__dZZU9a__collectorSetAccordionBody",
  "collectorSetAccordionButtonUltimate": "NextGen-module-scss-module__dZZU9a__collectorSetAccordionButtonUltimate",
  "collectorSetPill": "NextGen-module-scss-module__dZZU9a__collectorSetPill",
  "collectorSetPillSelected": "NextGen-module-scss-module__dZZU9a__collectorSetPillSelected",
  "copyData": "NextGen-module-scss-module__dZZU9a__copyData",
  "copyIcon": "NextGen-module-scss-module__dZZU9a__copyIcon",
  "countdownContainer": "NextGen-module-scss-module__dZZU9a__countdownContainer",
  "expandedOverview": "NextGen-module-scss-module__dZZU9a__expandedOverview",
  "exploreBtn": "NextGen-module-scss-module__dZZU9a__exploreBtn",
  "filterDropdown": "NextGen-module-scss-module__dZZU9a__filterDropdown",
  "flashing": "NextGen-module-scss-module__dZZU9a__flashing",
  "formInput": "NextGen-module-scss-module__dZZU9a__formInput",
  "globeIcon": "NextGen-module-scss-module__dZZU9a__globeIcon",
  "infoIcon": "NextGen-module-scss-module__dZZU9a__infoIcon",
  "listed": "NextGen-module-scss-module__dZZU9a__listed",
  "loader": "NextGen-module-scss-module__dZZU9a__loader",
  "logsScrollContainer": "NextGen-module-scss-module__dZZU9a__logsScrollContainer",
  "logsTable": "NextGen-module-scss-module__dZZU9a__logsTable",
  "marketplace": "NextGen-module-scss-module__dZZU9a__marketplace",
  "mintBtn": "NextGen-module-scss-module__dZZU9a__mintBtn",
  "mintDetails": "NextGen-module-scss-module__dZZU9a__mintDetails",
  "mintDetailsSpan": "NextGen-module-scss-module__dZZU9a__mintDetailsSpan",
  "mintSelect": "NextGen-module-scss-module__dZZU9a__mintSelect",
  "mintingForRadio": "NextGen-module-scss-module__dZZU9a__mintingForRadio",
  "navigationHeader": "NextGen-module-scss-module__dZZU9a__navigationHeader",
  "navigationHeaderHr": "NextGen-module-scss-module__dZZU9a__navigationHeaderHr",
  "nextgenBanner": "NextGen-module-scss-module__dZZU9a__nextgenBanner",
  "nextgenBannerWrapper": "NextGen-module-scss-module__dZZU9a__nextgenBannerWrapper",
  "nextgenCarousel": "NextGen-module-scss-module__dZZU9a__nextgenCarousel",
  "nextgenCarouselLeft": "NextGen-module-scss-module__dZZU9a__nextgenCarouselLeft",
  "nextgenCarouselRight": "NextGen-module-scss-module__dZZU9a__nextgenCarouselRight",
  "nextgenTag": "NextGen-module-scss-module__dZZU9a__nextgenTag",
  "nextgenTokenDetailsLinkSelected": "NextGen-module-scss-module__dZZU9a__nextgenTokenDetailsLinkSelected",
  "overview": "NextGen-module-scss-module__dZZU9a__overview",
  "phaseBox": "NextGen-module-scss-module__dZZU9a__phaseBox",
  "phaseTimeTagActive": "NextGen-module-scss-module__dZZU9a__phaseTimeTagActive",
  "phaseTimeTagComplete": "NextGen-module-scss-module__dZZU9a__phaseTimeTagComplete",
  "phaseTimeTagUpcoming": "NextGen-module-scss-module__dZZU9a__phaseTimeTagUpcoming",
  "previewBanner": "NextGen-module-scss-module__dZZU9a__previewBanner",
  "rarityDropdown": "NextGen-module-scss-module__dZZU9a__rarityDropdown",
  "slideshowContainer": "NextGen-module-scss-module__dZZU9a__slideshowContainer",
  "tokenContainer": "NextGen-module-scss-module__dZZU9a__tokenContainer",
  "tokenLogsTable": "NextGen-module-scss-module__dZZU9a__tokenLogsTable",
  "trafficLight": "NextGen-module-scss-module__dZZU9a__trafficLight",
  "trafficLightGreen": "NextGen-module-scss-module__dZZU9a__trafficLightGreen",
  "trafficLightOrange": "NextGen-module-scss-module__dZZU9a__trafficLightOrange",
  "trafficLightRed": "NextGen-module-scss-module__dZZU9a__trafficLightRed",
  "traitsAccordion": "NextGen-module-scss-module__dZZU9a__traitsAccordion",
  "traitsAccordionBody": "NextGen-module-scss-module__dZZU9a__traitsAccordionBody",
  "traitsAccordionItem": "NextGen-module-scss-module__dZZU9a__traitsAccordionItem",
  "viewAllTokens": "NextGen-module-scss-module__dZZU9a__viewAllTokens",
});
